export class Content {
  text: string;
  heading: string;
}

export interface PageContent {
  contentModels: Content[];
  version: number;
}
